/* eslint-disable max-len */
import { SvgProps } from './types'

/**
 * Ícone de preenchimento, diferente dos de contorno desta pasta: a cor vai
 * em fill, não em stroke.
 *
 * O viewBox foi apertado na tinta do arquivo original (noun_lowrates_8374471.svg),
 * que vinha com folga grande em volta do desenho — sem isso o ícone
 * apareceria bem menor que os vizinhos na mesma fileira.
 */
export const LowRatesIcon = ({ color, className }: SvgProps) => (
  <svg
    width="62.8"
    height="79.1"
    viewBox="23.5 20.5 62.8 79.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g>
      <path d="M29.3,73.1h.5c.7,0,1.3.2,1.8.7l2.6,2.2c.4.3.9.4,1.3.2s.8-.6.8-1.1V31.9c0-.7.6-1.2,1.2-1.2h8.1c.7,0,1.2-.6,1.2-1.2s-.6-1.2-1.2-1.2h-8.2c-2.1,0-3.8,1.7-3.8,3.8v40.4l-.6-.4c-.9-.8-2.2-1.2-3.4-1.2h-.5c-3.1,0-5.6,2.4-5.6,5.2s1,3.1,1.8,3.9l18,18c1.1,1.1,2.4,1.6,4,1.6s2.9-.6,4-1.7l17.6-18c1.6-1.6,1.9-3.8,1.1-5.8-.9-2-2.8-3.2-4.9-3.2s-2.5.4-3.4,1.2l-.5.4v-9.2c0-.7-.6-1.2-1.2-1.2s-1.2.6-1.2,1.2v11.9c0,.5.2.9.8,1.1.4.2.9.1,1.3-.2l2.6-2.2c.5-.4,1.2-.7,1.8-.7,1.4,0,2.2.9,2.6,1.8s.4,2.1-.6,3.1l-17.6,18c-.6.6-1.3.9-2.2.9s-1.6-.3-2.2-.9l-18-18c-.7-.7-1-1.4-1-2.1,0-1.3,1.1-2.7,3-2.7Z" fill={color} />
      <path d="M86.2,40.6c0-11-9-20-20-20s-20,9-20,20,9,20,20,20,20-9,20-20ZM66.2,58.1c-9.6,0-17.5-7.9-17.5-17.5s7.9-17.5,17.5-17.5,17.5,7.9,17.5,17.5-7.9,17.5-17.5,17.5Z" fill={color} />
      <path d="M75,32c-.5-.5-1.2-.5-1.8,0l-15.7,15.6c-.5.5-.5,1.2,0,1.8s.6.4.9.4.6-.1.9-.4l15.7-15.6c.5-.5.5-1.3,0-1.8Z" fill={color} />
      <path d="M60.3,38.8c2.2,0,4.1-1.8,4.1-4.1s-1.8-4.1-4.1-4.1-4.1,1.8-4.1,4.1,1.8,4.1,4.1,4.1ZM60.3,33.1c.9,0,1.6.7,1.6,1.6s-.7,1.6-1.6,1.6-1.6-.7-1.6-1.6.7-1.6,1.6-1.6Z" fill={color} />
      <path d="M72.2,42.5c-2.2,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1,4.1-1.8,4.1-4.1-1.8-4.1-4.1-4.1ZM72.2,48.1c-.9,0-1.6-.7-1.6-1.6s.7-1.6,1.6-1.6,1.6.7,1.6,1.6-.7,1.6-1.6,1.6Z" fill={color} />
    </g>
  </svg>
)
